/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback, useMemo } from "react";
import { useLocation, useNavigate, Navigate } from "react-router-dom";
import AuthContext from "../hooks/authContext";
import AppRoutes from "./app-route";
import theme from "../theme";
import Loader from "../components/AppLoader/Loader";
import { ThemeProvider } from "@material-ui/core/styles";
import { CssBaseline } from "@material-ui/core";
import { setLoginToken, clearLoginToken } from "../services/storage";
import { EventEmitter } from "../services/event.service";
import { getAuth, getIdToken, onAuthStateChanged } from "firebase/auth";
import { onSnapshot, doc, getDoc } from "firebase/firestore";
import { firebase } from "../services/firebase-config";
import { logOut, getCurrentUserQuick, mergeCompanyUserIntoUserData, updateUserSession } from "../services/firebase";
import { getDeviceInfo, markFreshAuthFlow, resolveServerSessionId } from "../utils/sessionDeviceInfo";
import {
  clearSessionEnteredViaForceLogin,
  hasSessionEnteredViaForceLogin,
} from "../utils/sessionFlags";
import ConcurrentSessionModal from "../components/session/ConcurrentSessionModal";
import PlanChangedModal from "../components/session/PlanChangedModal";
import {
  getSuppliesListCount,
  getSupplyOrderList,
} from "../services/apiservices/supplies";
import { getIssueListCount } from "../services/apiservices/issues";
import moment from "moment";
import {
  getCompanyEmployees,
  getEmployee,
} from "../services/apiservices/employee";
import {
  getChannelList,
  getUsedStorage,
} from "../services/apiservices/messages";
import { fetchSubscriptionWithCustomer, getCustomerPaymentMethods, getPendingPaymentVerificationByUser, getSubscriptionSchedule, getPlanAccessByStripeProductId, subscribePlanAccessByStripeProductId, getAllPlansAccess } from "../services/apiservices/users";
import { getCompanyClients } from "../services/apiservices/client";
import { getSupportListCount } from "../services/apiservices/support";
import { DOMAIN_TYPE, DOMAIN_TYPES } from "../services/config";
import ErrorBoundary from "../components/ErrorBoundary/ErrorBoundary";
import TourBubble from "../components/ui/TourBubble";
import AuthenticatedApp from "./AppShell";
import { getCompanyAppointmentsSample } from "../services/apiservices/appoinments";
import { trackPageView } from "../services/apiservices/analytics";
import { sessionManager } from "../services/sessionManager";
import { ENABLE_GUIDED_TOUR } from "../services/featureFlags";
import { OnboardingExperienceProvider } from "../components/onboarding/OnboardingExperienceProvider";
import { enforcePlanDowngradeSettings } from "../services/planSettingsEnforcer";
import { getSeatAddonQuantities } from "../services/helpers";

const PUBLIC_AUTH_ROUTES = [
  "/",
  "/login",
  "/register",
  "/verify-email-sent",
  "/verify-email",
  "/verify-new-email",
  "/updatepassword",
  "/complete-registration",
  "/forgotpassword",
  "/invoices/pay",
  "/invoices/pay/success",
];

function App(props) {
  const [authstatus, setauthstatus] = useState(false);
  const [substatus, setsubstatus] = useState(false);
  const [userProfile, setUserProfile] = useState(false);
  const [isLoading, setIsLoading] = useState(() => !PUBLIC_AUTH_ROUTES.includes(window.location?.pathname || ""));
  const [emps, setEmps] = useState([]);
  const [clients, setClients] = useState([]);
  const [currentChannel, setCurrentChannel] = useState();
  const [companyAppointmentsSample, setCompanyAppointmentsSample] = useState([]);
  const [guidedTourEligibility, setGuidedTourEligibility] = useState({
    isResolved: false,
    hasClients: false,
    hasEmployees: false,
    hasAppointments: false,
  });
  const [isReadPublic, setIsReadPublic] = useState();
  const [isReadPrivate, setIsReadPrivate] = useState();
  const [supplyId, setSupplyId] = useState();
  const [supplieStatusCount, setSupplieStatusCount] = useState({
    Pending: 0,
    OPEN: 0,
  });
  const [pendingSupplyStatus, setPendingSupplyStatus] = useState([]);
  const [pendingSupportStatus, setPendingSupportStatus] = useState(0);
  const [highPrioritySupply, setHighPrioritySupply] = useState([]);
  const [appointmentsData, setAppointmentsData] = useState({});
  const [editAppointmentData, setEditAppointmentData] = useState({});
  const [updateAppointmentData, setUpdateAppointmentData] = useState({});
  const [isExpanded, setIsExpanded] = useState(false);
  const [selectedAppointment, setSelectedAppointment] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);
  const [loginBack, setLoginBack] = useState(false);
  const [issueCount, setIssueCount] = useState(0);
  const [newClientId, setNewClientId] = useState();
  const [newEmpId, setNewEmpId] = useState();
  // eslint-disable-next-line no-unused-vars
  const [allEmp, setAllEmps] = useState();
  const [sessionWarning, setSessionWarning] = useState(false);
  const [concurrentSessionModalOpen, setConcurrentSessionModalOpen] = useState(false);
  const [concurrentSessionModalVariant, setConcurrentSessionModalVariant] = useState("competing");
  const [concurrentSessionContinueLoading, setConcurrentSessionContinueLoading] = useState(false);
  const [planChangedModalOpen, setPlanChangedModalOpen] = useState(false);
  const [planChangedLogoutLoading, setPlanChangedLogoutLoading] = useState(false);

  const [reportData, setReportData] = useState({
    FileName: "",
    ReportsName: "",
    Name: "",
    Date: "",
    EndDate: "",
    fullData: "",
    fullExcelData: "",
    pdf: "",
    storedData: ""
  });
  const [tableState, setTableState] = useState({
    sort: false,
    rowsPerPage: 10,
  });
  const location = useLocation();
  const path = location.pathname;
  const navigate = useNavigate();
  const localCompanyId = localStorage.getItem('companyId');

  const LOGIN_CACHE_TTL_MS = 90 * 1000;
  const LOGIN_CACHE_STALE_TTL_MS = 30 * 60 * 1000;
  const LOGIN_CACHE_PREFIX = "login_cache_";
  const AUTH_STORAGE_KEYS = [
    "sessionId",
    "sessionSyncAt",
    "authFlowAt",
    "companies",
    "clients",
    "companyId",
    "clientId",
    "token",
    "pcIdleExpiry",
    "pcAbsoluteExpiry",
    "forceLoginPending",
    "hasSeenTour",
  ];

  const applyLoginCache = (cache, currentuser) => {
    const cachedProfile = cache.userProfile || {};
    const cachedPlanAccess =
      cachedProfile?.planAccess || cachedProfile?.plansAccess || null;
    const cachedPlanId = cachedProfile?.prdId || null;
    if (typeof window !== "undefined") {
      window.__CURRENT_PLAN_ACCESS__ = cachedPlanAccess;
      if (cachedPlanId && cachedPlanAccess) {
        window.__PLAN_ACCESS_BY_PRODUCT__ = {
          ...(window.__PLAN_ACCESS_BY_PRODUCT__ || {}),
          [cachedPlanId]: cachedPlanAccess,
        };
      }
    }

    setLoginToken(cache.token || currentuser?.token);
    setClients(cache.clients || []);
    setEmps(cache.emps || []);
    setCompanyAppointmentsSample(cache.appointments || []);
    setGuidedTourEligibility({
      isResolved: true,
      hasClients: Array.isArray(cache.clients) && cache.clients.length > 0,
      hasEmployees: Array.isArray(cache.emps) && cache.emps.length > 0,
      hasAppointments: Array.isArray(cache.appointments) && cache.appointments.length > 0,
    });
    setAllEmps(cache.allEmps || []);
    setUserProfile(cachedProfile);
    setauthstatus(true);
    setsubstatus(cache.substatus ?? false);
    setIsLoading(false);
  };

  const saveLoginCache = (cache) => {
    const payload = JSON.stringify({ ...cache, timestamp: Date.now() });
    const key = `${LOGIN_CACHE_PREFIX}${cache.userId}`;
    try {
      sessionStorage.setItem(key, payload);
      localStorage.setItem(key, payload);
    } catch (e) {
      if (e?.name === "QuotaExceededError") {
        try { sessionStorage.removeItem(key); localStorage.removeItem(key); } catch (_) {}
      }
    }
  };

  const updateCachedPlanAccess = (userId, livePlanAccess) => {
    if (!userId) return;

    const key = `${LOGIN_CACHE_PREFIX}${userId}`;
    const updateStoredCache = (storage) => {
      const rawCache = storage.getItem(key);
      if (!rawCache) return;

      try {
        const parsed = JSON.parse(rawCache);
        const nextCache = {
          ...parsed,
          userProfile: {
            ...(parsed?.userProfile || {}),
            planAccess: livePlanAccess,
            plansAccess: livePlanAccess,
          },
          timestamp: Date.now(),
        };
        storage.setItem(key, JSON.stringify(nextCache));
      } catch (_e) {
        storage.removeItem(key);
      }
    };

    updateStoredCache(sessionStorage);
    updateStoredCache(localStorage);
  };

  const clearAuthStorage = () => {
    AUTH_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
    clearSessionEnteredViaForceLogin();
    try {
      Object.keys(sessionStorage)
        .filter((k) => k.startsWith(LOGIN_CACHE_PREFIX))
        .forEach((k) => sessionStorage.removeItem(k));
      Object.keys(localStorage)
        .filter((k) => k.startsWith(LOGIN_CACHE_PREFIX))
        .forEach((k) => localStorage.removeItem(k));
    } catch (_e) {
      // ignore
    }
    if (typeof window !== "undefined") {
      window.__CURRENT_PLAN_ACCESS__ = null;
      window.__PLAN_ACCESS_BY_PRODUCT__ = {};
    }
  };

  const getSupplyCount = async (companyId, role) => {
    const isClient = Array.isArray(role) ? role.includes("Client") : role === "Client";
    if (isClient) {
      setPendingSupplyStatus([]);
      setSupplieStatusCount({});
      return;
    }

    await getSuppliesListCount(
      {
        status: ["Pending"],
        companyId: companyId,
      },
      (res) => {
        if (res[0]?.Pending === 0) {
          setPendingSupplyStatus([]);
        } else {
          setPendingSupplyStatus(res);
        }

        setSupplieStatusCount(res[0]);
      }
    );
  };

  const getSupportCount = async (companyId, userId, role) => {
    const isClient = Array.isArray(role) ? role.includes("Client") : role === "Client";
    if (isClient) {
      setPendingSupportStatus(0);
      return;
    }

    await getSupportListCount(
      {
        userId: userId,
        companyId: companyId,
      },
      (res) => {
        if (res[0]?.unread === 0) {
          setPendingSupportStatus(0);
        } else {
          setPendingSupportStatus(res[0]?.unread);
        }

        setPendingSupportStatus(res[0]?.unread);
      }
    );
  };

  const getIssueCount = async (companyId, clientId, userId) => {
    await getIssueListCount(
      {
        companyId: companyId,
        clientId: clientId,
        userId: userId
      },
      (res) => {
        if (res?.[0]?.unread === 0) {
          setIssueCount(0);
        } else {
          setIssueCount(res?.[0]?.unread);
        }
      }
    );
  };

  const getHighPrioritySupply = async (companyId, role, userId) => {
    const isClient = Array.isArray(role) ? role.includes("Client") : role === "Client";
    if (isClient) {
      setHighPrioritySupply([]);
      return;
    }

    await getSupplyOrderList({ companyId, statusNotIn: ["Pending", "Rejected"] }, (res) => {
      // let records = res.filter(
      //   (order) => order.status !== "Pending" && order.status !== "Rejected"
      // );
      let filterRecords = res?.filter((order) => {
        const readUser = order?.readUser || [];
        const isUnread = !readUser.includes(userId);
        const archive = !order?.archive
        return (
          ((order?.status !== "Delivered" || isUnread) && archive)
        );
      });
      setHighPrioritySupply(filterRecords);
    });
  };

  const getTheChannelList = async (companyId, id, role) => {
    const isClient = Array.isArray(role) ? role.includes("Client") : role === "Client";
    const unsubscribe = await getChannelList(companyId,
      (res) => {
        if (res) {
          const data = res?.filter((item) => item.status !== false);
          let isReadPriv = true;
          let isReadPubl = true;
          data?.forEach((element) => {
            if (element.type === "Private") {
              if (isClient && element?.client !== id) {
                return;
              }
              if (isReadPriv) {
                isReadPriv = element?.readMsgUsers?.includes(id) ? true : false;
              }
            } else {
              if (isReadPubl) {
                isReadPubl = element?.readMsgUsers?.includes(id) ? true : false;
              }
            }
          });

          setIsReadPublic(isReadPubl);
          setIsReadPrivate(isReadPriv);
        }
      },
      (_resError) => {
        // Error handled silently
      }
    );
    return unsubscribe;
  };

  function AnalyticsTracker() {
    const location = useLocation();

    useEffect(() => {
      trackPageView(location.pathname);
    }, [location]);

    return null;
  }

  // Store auth unsubscribe function in ref to persist across renders
  const authUnsubscribeRef = React.useRef(null);
  // Store channel listener unsubscribe so it can be cleaned up on logout/unmount
  const channelUnsubscribeRef = React.useRef(null);
  // Store session listener unsubscribe
  const sessionUnsubscribeRef = React.useRef(null);
  const planAccessUnsubscribeRef = React.useRef(null);
  const companyPlanUnsubscribeRef = React.useRef(null);
  const observedPlanProductIdRef = React.useRef(null);
  const enforcedPlanKeyRef = React.useRef("");
  const lastEnforcedPlanIdRef = React.useRef(null);
  const sessionCheckSkipFirstRef = React.useRef(true);
  const concurrentSessionLogoutTimeoutRef = React.useRef(null);
  const startupFetchRef = React.useRef({
    key: "",
    timestamp: 0,
    promise: null,
  });
  /** Fresh password login already fetched users/{uid} in loginWithEmail — skip duplicate read in onAuthStateChanged */
  const loginPreloadRef = React.useRef(null);
  /** While concurrent-session modal is open or resolving — avoid duplicate debounced prompts */
  const concurrentSessionModalBlockingRef = React.useRef(false);
  const pathRef = React.useRef(path);
  pathRef.current = path;

  // Always holds the latest logoutuser reference so stable event callbacks
  // (EventEmitter handler, sessionManager timeout) never capture a stale closure.
  const logoutRef = React.useRef(null);
  const lastFocusRef = React.useRef(Date.now());

  const getSubscriptionProductId = useCallback((userData) => {
    if (!userData) return null;
    const subscription = userData?.subscriptions?.data?.[0];
    return (
      subscription?.plan?.product ||
      subscription?.items?.data?.[0]?.price?.product ||
      null
    );
  }, []);

  const clearCompanyPlanListener = useCallback(() => {
    if (companyPlanUnsubscribeRef.current) {
      companyPlanUnsubscribeRef.current();
      companyPlanUnsubscribeRef.current = null;
    }
    observedPlanProductIdRef.current = null;
  }, []);

  const openPlanChangedModal = useCallback(() => {
    setPlanChangedModalOpen(true);
  }, []);

  const runPlanSettingsEnforcement = useCallback(
    async ({ companyId, planId, planAccess }) => {
      if (!companyId || !planId || !planAccess) return;
      const nextKey = `${companyId}:${planId}`;
      if (enforcedPlanKeyRef.current === nextKey) return;
      const previousPlanId = lastEnforcedPlanIdRef.current;
      enforcedPlanKeyRef.current = nextKey;
      lastEnforcedPlanIdRef.current = planId;
      try {
        await enforcePlanDowngradeSettings({
          companyId,
          previousPlanId,
          planId,
          planAccess,
        });
      } catch (error) {
        console.error("Failed to enforce downgrade settings:", error);
      }
    },
    []
  );

  const startCompanyPlanListener = useCallback(
    ({ isCompanyUser, trackedUserId, initialPlanProductId }) => {
      clearCompanyPlanListener();
      if (isCompanyUser || !trackedUserId) return;

      observedPlanProductIdRef.current = initialPlanProductId || null;

      const trackedUserRef = doc(firebase, "users", trackedUserId);
      companyPlanUnsubscribeRef.current = onSnapshot(
        trackedUserRef,
        { includeMetadataChanges: true },
        (trackedDoc) => {
          if (!trackedDoc.exists() || trackedDoc.metadata?.fromCache) return;

          const livePlanProductId = getSubscriptionProductId(trackedDoc.data());
          if (!livePlanProductId) return;

          if (!observedPlanProductIdRef.current) {
            observedPlanProductIdRef.current = livePlanProductId;
            return;
          }

          if (observedPlanProductIdRef.current !== livePlanProductId) {
            observedPlanProductIdRef.current = livePlanProductId;
            clearCompanyPlanListener();
            openPlanChangedModal();
          }
        }
      );
    },
    [clearCompanyPlanListener, getSubscriptionProductId, openPlanChangedModal]
  );

  // Initialize or pause global auth listener based on current route
  useEffect(() => {
    const excludedRoutes = [
      "/",
      "/login",
      "/register",
      "/verify-email-sent",
      "/verify-email",
      "/verify-new-email",
      "/updatepassword",
      "/complete-registration",
      "/forgotpassword"
    ];

    // On auth-excluded routes (like the login page), make sure the listener is stopped
    if (excludedRoutes.includes(path)) {
      if (authUnsubscribeRef.current && typeof authUnsubscribeRef.current === "function") {
        authUnsubscribeRef.current();
        authUnsubscribeRef.current = null;
      }
      setIsLoading(false);
      return;
    }

    if (!authstatus && !authUnsubscribeRef.current) {
      startAuthListener();
    }
  }, [path, authstatus]);

  useEffect(() => {
    return () => {
      if (channelUnsubscribeRef.current) {
        channelUnsubscribeRef.current();
        channelUnsubscribeRef.current = null;
      }
      if (sessionUnsubscribeRef.current) {
        sessionUnsubscribeRef.current();
        sessionUnsubscribeRef.current = null;
      }
      if (planAccessUnsubscribeRef.current) {
        planAccessUnsubscribeRef.current();
        planAccessUnsubscribeRef.current = null;
      }
      if (companyPlanUnsubscribeRef.current) {
        companyPlanUnsubscribeRef.current();
        companyPlanUnsubscribeRef.current = null;
      }
      if (concurrentSessionLogoutTimeoutRef.current) {
        clearTimeout(concurrentSessionLogoutTimeoutRef.current);
        concurrentSessionLogoutTimeoutRef.current = null;
      }
      if (authUnsubscribeRef.current && typeof authUnsubscribeRef.current === "function") {
        authUnsubscribeRef.current();
        authUnsubscribeRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    const excludedRoutes = [
      "/",
      "/login",
      "/register",
      "/verify-email-sent",
      "/verify-email",
      "/verify-new-email",
      "/updatepassword",
      "/complete-registration",
      "/forgotpassword"
    ];

    if (excludedRoutes.includes(path)) {
      console.log("Skipping login for this route:", path);
    }
  }, [path]);

  const resetPendingSupplyStatus = useCallback(() => setPendingSupplyStatus([]), []);
  const resetPendingSupportStatus = useCallback(() => setPendingSupportStatus(), []);
  const resetHighPrioritySupply = useCallback(() => setHighPrioritySupply([]), []);
  const resetIssueCount = useCallback(() => setIssueCount(0), []);

  const loadStartupSidebarSignals = useCallback((companyId, currentUserData) => {
    const roleKey = Array.isArray(currentUserData?.role)
      ? currentUserData.role.join("|")
      : currentUserData?.role || "";
    const dedupeKey = `${companyId || ""}:${currentUserData?.id || ""}:${roleKey}`;
    const now = Date.now();
    const dedupeTtlMs = 15000;
    const existing = startupFetchRef.current;

    if (
      existing?.promise &&
      existing?.key === dedupeKey &&
      now - (existing?.timestamp || 0) < dedupeTtlMs
    ) {
      return existing.promise;
    }

    const request = Promise.all([
      getSupplyCount(companyId, currentUserData?.role).catch(() => null),
      getSupportCount(companyId, currentUserData?.id, currentUserData?.role).catch(() => null),
      getIssueCount(companyId, currentUserData?.client, currentUserData?.id).catch(() => null),
      getTheChannelList(companyId, currentUserData?.id, currentUserData?.role).catch(() => null),
    ])
      .then(([, , , unsub]) => {
        if (typeof unsub === "function") {
          channelUnsubscribeRef.current = unsub;
        }
      })
      .finally(() => {
        startupFetchRef.current = {
          key: dedupeKey,
          timestamp: Date.now(),
          promise: null,
        };
      });

    startupFetchRef.current = {
      key: dedupeKey,
      timestamp: now,
      promise: request,
    };

    return request;
  }, []);

  const validateSubscription = (subscriptionEndTimestamp) => {
    const subscriptionEndDate = moment.unix(subscriptionEndTimestamp).format("YYYY-MM-DD");
    const today = moment().format("YYYY-MM-DD");
    return subscriptionEndDate >= today;
  };

  const isSubscriptionValid = (subscription, fallback, currentUserData) => {
    const now = moment().unix();
    const endTimestamp =
      fallback?.current_period_end || fallback?.items?.data?.[0]?.current_period_end || subscription?.current_period_end;
    const status = fallback?.status || subscription?.status;
    const cancelAtPeriodEnd =
      fallback?.current_period_end || fallback?.items?.data?.[0]?.current_period_end || subscription?.current_period_end || false;

    const graceActive = currentUserData?.graceActive || false;

    return (
      endTimestamp &&
      validateSubscription(endTimestamp) &&
      (["active", "trialing"].includes(status) || graceActive ||
        (status === "canceled" && cancelAtPeriodEnd && now <= endTimestamp))
    );
  };

  const isRoleAllowedForDomain = (userRoles = []) => {
    const isClient = userRoles.includes("Client");
    const isSuperUser = userRoles.includes("superUser");

    switch (DOMAIN_TYPE) {
      case DOMAIN_TYPES.SUPERUSER_ONLY:
        return isSuperUser;

      case DOMAIN_TYPES.CLIENT_ONLY:
        return isClient;

      case DOMAIN_TYPES.ALL:
      default:
        return true;
    }
  };

  const normalizeRoles = (roleValue) => {
    if (Array.isArray(roleValue)) return roleValue.filter(Boolean);
    return roleValue ? [roleValue] : [];
  };

  const AUTH_FLOW_WINDOW_MS = 2 * 60 * 1000;
  const SESSION_CHECK_GRACE_MS = 45 * 1000;

  const isFreshManualAuthFlow = () => {
    const authFlowAt = parseInt(localStorage.getItem("authFlowAt") || "0", 10);
    return !!authFlowAt && Date.now() - authFlowAt < AUTH_FLOW_WINDOW_MS;
  };

  const isWithinSessionPropagationGrace = () => {
    const sessionSyncAt = parseInt(localStorage.getItem("sessionSyncAt") || "0", 10);
    return !!sessionSyncAt && Date.now() - sessionSyncAt < SESSION_CHECK_GRACE_MS;
  };

  const hasConcurrentSessionMismatch = (remoteData) => {
    const remoteSessionId = remoteData?.sessionId || remoteData?.session?.id || remoteData?.session?.sessionId;
    const remoteDeviceId = remoteData?.session?.deviceId;
    const localSessionId = localStorage.getItem("sessionId");
    const localDeviceId = localStorage.getItem("deviceId");

    // Device match is authoritative for "same browser/device" and avoids
    // false concurrent-session logouts while backend session IDs propagate.
    if (remoteDeviceId && localDeviceId && remoteDeviceId === localDeviceId) {
      return false;
    }

    const sessionMismatch =
      !!remoteSessionId && !!localSessionId && remoteSessionId !== localSessionId;
    const deviceMismatch =
      !!remoteDeviceId && !!localDeviceId && remoteDeviceId !== localDeviceId;

    return sessionMismatch || deviceMismatch;
  };

  const shouldSkipConcurrentSessionCheck = (remoteData) => {
    // If Firestore already reflects a different device/session than this browser, never skip —
    // otherwise the post-login grace window hides takeovers (e.g. device A "Continue here"
    // while device B still has recent authFlowAt from its own login).
    if (remoteData && hasConcurrentSessionMismatch(remoteData)) {
      return false;
    }
    // Same device: allow brief propagation lag without false positives.
    return isFreshManualAuthFlow() || isWithinSessionPropagationGrace();
  };

  const startSessionTimers = ({ resetExisting } = {}) => {
    if (resetExisting) {
      sessionManager.restartFresh();
      localStorage.removeItem("authFlowAt");
      return;
    }
    sessionManager.start();
  };


  const login = (_token) => {
    // Do not set global loading here: it flashes the main shell overlay during sign-in.
    // Initial route load still uses isLoading from useState / applyLoginCache / callback completion.
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      // If we're waiting for user to solve a session conflict, don't auto-login
      if (localStorage.getItem("forceLoginPending") === "true") {
        console.warn("Skipping automatic login: session conflict pending resolution");
        setIsLoading(false);
        return;
      }

      if (!user) {
        clearCompanyPlanListener();
        setauthstatus(false);
        setsubstatus(false);
        setIsLoading(false);
        return;
      }
      try {

        const userData = auth.currentUser;
        const preload = loginPreloadRef.current;
        loginPreloadRef.current = null;

        let currentuser;
        const preloadOk = preload?.userData?.id === user.uid;
        if (preloadOk) {
          currentuser = {
            user: auth.currentUser,
            userData: preload.userData,
            token: preload.token || (await getIdToken(auth.currentUser)),
          };
        } else {
          currentuser = await getCurrentUserQuick();
        }
        setLoginToken(currentuser?.token);
        let currentUserData = currentuser?.userData || {};

        const userDocRef = doc(firebase, "users", user.uid);

        if (sessionUnsubscribeRef.current) {
          sessionUnsubscribeRef.current();
        }
        if (concurrentSessionLogoutTimeoutRef.current) {
          clearTimeout(concurrentSessionLogoutTimeoutRef.current);
          concurrentSessionLogoutTimeoutRef.current = null;
        }

        sessionCheckSkipFirstRef.current = true;
        sessionUnsubscribeRef.current = onSnapshot(
          userDocRef,
          { includeMetadataChanges: true },
          (docSnap) => {
            if (docSnap.metadata?.fromCache) {
              return;
            }
            // Skip first server snapshot: on refresh, it can be stale (cache/replication).
            if (sessionCheckSkipFirstRef.current) {
              sessionCheckSkipFirstRef.current = false;
              return;
            }
            if (!docSnap.exists()) {
              return;
            }
            const data = docSnap.data();
            // Grace period after login: skip only when this snapshot still matches this device
            // (propagation lag). Never skip when another device already owns the session.
            if (shouldSkipConcurrentSessionCheck(data)) {
              return;
            }
            const currentPath = pathRef.current || "";
            const isEmployeePage = currentPath.includes("/peoples/manageEmp") || currentPath.includes("/peoples/inactiveEmp");
            if (isEmployeePage) return;
            if (hasConcurrentSessionMismatch(data)) {
              if (concurrentSessionModalBlockingRef.current) {
                return;
              }
              // Debounce + confirm: avoid false positives from replication/ordering races.
              if (concurrentSessionLogoutTimeoutRef.current) {
                clearTimeout(concurrentSessionLogoutTimeoutRef.current);
              }
              concurrentSessionLogoutTimeoutRef.current = setTimeout(async () => {
                concurrentSessionLogoutTimeoutRef.current = null;
                try {
                  const latestSnap = await getDoc(userDocRef);
                  if (!latestSnap.exists()) return;

                  const latestData = latestSnap.data() || {};
                  if (shouldSkipConcurrentSessionCheck(latestData)) {
                    return;
                  }
                  if (hasConcurrentSessionMismatch(latestData)) {
                    if (concurrentSessionModalBlockingRef.current) {
                      return;
                    }
                    console.warn("Concurrent session confirmed. Showing takeover modal.");
                    concurrentSessionModalBlockingRef.current = true;
                    setConcurrentSessionModalVariant(
                      hasSessionEnteredViaForceLogin() ? "kicked" : "competing"
                    );
                    setConcurrentSessionModalOpen(true);
                  }
                } catch (_e) {
                  // Keep session when confirmation cannot be completed to avoid accidental logouts.
                }
              }, 3000);
            } else {
              // Session matches or no session — cancel any pending logout
              if (concurrentSessionLogoutTimeoutRef.current) {
                clearTimeout(concurrentSessionLogoutTimeoutRef.current);
                concurrentSessionLogoutTimeoutRef.current = null;
              }
            }
          }
        );

        let userRoles = [];

        if (Array.isArray(currentUserData?.role)) {
          userRoles = [...currentUserData.role];
        } else if (typeof currentUserData?.role === "string") {
          userRoles = [currentUserData.role];
        }

        if (userRoles?.includes("Employee") && currentUserData?.employeerole) {
          userRoles.push(currentUserData.employeerole);
        }

        userRoles = [...new Set(userRoles?.filter(Boolean))];

        if (!isRoleAllowedForDomain(userRoles)) {
          setauthstatus(false);
          setsubstatus(false);
          setIsLoading(false);

          await logoutuser();
          return;
        }

        // ── Stale-session guard ──────────────────────────────────────────────
        // On page-load / auth-restore, enforce session expiry BEFORE any
        // authenticated state is applied. If the user returns after an idle gap
        // of >30 min or a total session age of >8 hours, log them out immediately.
        // Fresh logins have no stored timestamps so checkStaleSession() returns null.
        const freshManualAuthFlow = isFreshManualAuthFlow();

        const staleReason = sessionManager.checkStaleSession();
        if (staleReason && !freshManualAuthFlow) {
          console.info(`[Session] Stale session on restore (${staleReason}). Logging out.`);
          logoutuser();
          return;
        }
        // ────────────────────────────────────────────────────────────────────

        const isClient = userRoles?.includes("Client");
        const isCompanyUser = userRoles?.includes("companyUser");
        const isSuperUser = userRoles?.includes("superUser");
        const baseUserProfile = {
          ...currentUserData,
          emailVerified: user?.emailVerified,
          lastLogin: userData?.metadata?.lastSignInTime,
        };
        // Clear account-scoped UI data before setting auth true so previous account
        // details never flash when switching users.
        setLoginBack(false);
        setClients([]);
        setEmps([]);
        setAllEmps([]);
        setCompanyAppointmentsSample([]);
        setGuidedTourEligibility({
          isResolved: false,
          hasClients: false,
          hasEmployees: false,
          hasAppointments: false,
        });
        setUserProfile(baseUserProfile);
        setauthstatus(true);
        // const role = currentUserData?.role === "Employee"
        //   ? currentUserData?.employeerole
        //   : currentUserData?.role;
        const companyId = isClient ? localCompanyId || currentUserData?.companyId : isCompanyUser ? currentUserData?.id : currentUserData?.companyId;

        // const companyId = currentUserData?.role === "Client" ? localCompanyId ? localCompanyId : currentUserData?.companyId : currentUserData?.role === "companyUser" ? currentUserData?.id : currentUserData?.companyId;

        if (isSuperUser) {
          setLoginToken(currentuser?.token);
          setUserProfile(baseUserProfile);
          setsubstatus(false);
          setIsLoading(false);
          startSessionTimers({ resetExisting: freshManualAuthFlow });
          return;
        }

        // Second Firestore read (company owner doc) for Stripe customer — runs after auth is true so login → shell is not blocked on two sequential reads.
        if (!isCompanyUser && !isSuperUser) {
          currentUserData = await mergeCompanyUserIntoUserData(currentUserData);
          currentuser = { ...currentuser, userData: currentUserData };
          setUserProfile((prev) =>
            prev
              ? {
                  ...prev,
                  customer: currentUserData.customer,
                  subscriptions: currentUserData.subscriptions,
                }
              : prev
          );
        }

        // if (currentUserData?.role === "companyUser" && !user.emailVerified) {
        //   setIsLoading(false);
        //   navigate("/verify-email-sent");
        //   return;
        // }

        // Fast reload: use cache if valid (sessionStorage first, then localStorage for refresh)
        const cacheKey = `${LOGIN_CACHE_PREFIX}${user.uid}`;
        let cachedRaw = sessionStorage.getItem(cacheKey);
        if (!cachedRaw) cachedRaw = localStorage.getItem(cacheKey);
        let usedCache = false;
        if (cachedRaw) {
          try {
            const parsed = JSON.parse(cachedRaw);
            const age = Date.now() - (parsed.timestamp || 0);
            const isFresh = age < LOGIN_CACHE_TTL_MS;
            const isStale = age < LOGIN_CACHE_STALE_TTL_MS;
            if (parsed.companyId === companyId && parsed.userProfile && (isFresh || isStale)) {
              usedCache = true;
              applyLoginCache(parsed, currentuser);
              startSessionTimers({ resetExisting: freshManualAuthFlow });
              loadStartupSidebarSignals(companyId, currentUserData);
              setTimeout(() => {
                getHighPrioritySupply(companyId, currentUserData?.role, currentUserData?.id);
              }, 100);
            }
          } catch (_e) {
            try { sessionStorage.removeItem(cacheKey); localStorage.removeItem(cacheKey); } catch (_) {}
          }
        }

        if (usedCache) {
          // Run full fetch in background to refresh data; will update state when complete
          (async () => {
            try {
              const paymentPromise = isCompanyUser
                ? Promise.all([
                  getPendingPaymentVerificationByUser(currentUserData?.id, ["during_verification", "pending_verification"]),
                  getCustomerPaymentMethods(currentUserData?.customer)
                ])
                : Promise.resolve([{ during_verification: [], pending_verification: [] }, null]);
              const mainDataPromise = Promise.all([
                fetchSubscriptionWithCustomer(currentUserData?.customer),
                getUsedStorage(companyId),
                new Promise((resolve) => {
                  getCompanyEmployees(companyId, (r) => resolve(r), () => resolve({ status: false, data: [] }));
                }),
                new Promise((resolve) => {
                  getCompanyClients(companyId, (r) => resolve(r), () => resolve({ status: false, data: [] }), { pageSize: 15 });
                }),
                new Promise((r) => getEmployee(companyId, r)),
                getCompanyAppointmentsSample(companyId, 5)
              ]);
              const [[subscriptionData, storage, allEmpRes, clientRes, companyData, appointmentRes], paymentResult] = await Promise.all([mainDataPromise, paymentPromise]);
              if (!subscriptionData?.data?.length) return;
              let pVerifications = [];
              let pACH = [];
              let pCardsData = {};
              if (isCompanyUser && paymentResult) {
                const [pr, pm] = paymentResult;
                if (pr?.during_verification?.length) pVerifications = pr.during_verification;
                if (pr?.pending_verification?.length) {
                  pACH = pr.pending_verification.map((item) => ({
                    id: item.paymentMethod.id,
                    setupIntentId: item.setupIntentId,
                    type: "us_bank_account",
                    bank_name: item.paymentMethod.us_bank_account?.bank_name,
                    last4: item.paymentMethod.us_bank_account?.last4,
                    account_holder_type: item.paymentMethod.us_bank_account?.account_holder_type,
                    account_type: item.paymentMethod.us_bank_account?.account_type,
                    status: item.status,
                  }));
                }
                pCardsData = {
                  cards: [...(pm?.cards || []), ...pACH],
                  defaultPaymentMethodId: pm?.defaultPaymentMethodId
                };
              }
              const clientsDetails = clientRes?.data?.filter((i) => i?.status !== false) || [];
              const employees = allEmpRes?.data?.filter((i) => i?.status !== false) || [];
              const appointments = appointmentRes?.appointments || [];
              const subscriptions = subscriptionData?.data || [];
              const blockedPriceIds = new Set(["price_1R1Pm6H54HzvHwSdzS4aA0s9", "price_1RGH20H54HzvHwSdZTHWjNHO"]);
              let activeSub = null, trialingSub = null, latestCanceled = null;
              subscriptions.forEach((sub) => {
                if (sub?.items?.data?.some((i) => blockedPriceIds.has(i?.price?.id))) return;
                if (sub?.status === "active" && !activeSub) activeSub = sub;
                else if (sub?.status === "trialing" && !trialingSub) trialingSub = sub;
                else if (sub?.status === "canceled") {
                  if (!latestCanceled || sub?.created > latestCanceled?.created) latestCanceled = sub;
                }
              });
              const fallbackSub = activeSub || trialingSub || latestCanceled;
              let subscriptionSchedule = null;
              if (fallbackSub?.schedule) {
                subscriptionSchedule = await getSubscriptionSchedule(fallbackSub.schedule);
              }
              const userSub = currentUserData?.subscriptions?.data?.[0];
              const additionalSubscriptions = currentUserData?.subscriptions?.additionalData || [];
              const subStatus = fallbackSub?.status || userSub?.status;
              const subId = fallbackSub?.plan?.product || userSub?.plan?.product;
              const planAccess = await getPlanAccessByStripeProductId(subId);
              const seatAddons = getSeatAddonQuantities(additionalSubscriptions, validateSubscription);
              let qty = subStatus === "trialing"
                ? 5
                : (userSub?.quantity || fallbackSub?.quantity || 0) + (seatAddons.fieldUser || 0);
              const companyActiveUsers = currentUserData?.role === "companyUser"
                ? (allEmpRes?.data || []).reduce((c, e) => (e.companyId === currentUserData?.id && e.role === "Employee" && e.status) ? c + 1 : c, 0)
                : 0;
              const isValid = isSubscriptionValid(userSub, fallbackSub, currentUserData);
              setCompanyAppointmentsSample(appointments);
              setClients(clientsDetails);
              setEmps(employees);
              setGuidedTourEligibility({
                isResolved: true,
                hasClients: clientsDetails.length > 0,
                hasEmployees: employees.length > 0,
                hasAppointments: appointments.length > 0,
              });
              setAllEmps(allEmpRes?.data || []);
              const freshProfile = {
                ...currentUserData,
                emailVerified: user?.emailVerified,
                subscriptionDetails: fallbackSub,
                subscriptionSchedule,
                companyActiveUsers,
                lastLogin: user?.metadata?.lastSignInTime,
                prdId: subId,
                fieldAdditionalQuantity: seatAddons.fieldUser || 0,
                backOfficeAdditionalQuantity: seatAddons.backOffice || 0,
                quantity: qty,
                storage,
                clientsLength: clientsDetails?.length,
                employeesLength: employees?.length,
                employees: allEmpRes?.data,
                companyData,
                pendingVerifications: pVerifications,
                cardsData: pCardsData,
                cardsDataLoaded: true,
                planAccess : planAccess
              };
              if (typeof window !== "undefined") {
                window.__CURRENT_PLAN_ACCESS__ = planAccess || null;
                if (subId && planAccess) {
                  window.__PLAN_ACCESS_BY_PRODUCT__ = {
                    ...(window.__PLAN_ACCESS_BY_PRODUCT__ || {}),
                    [subId]: planAccess,
                  };
                }
              }
              if (planAccessUnsubscribeRef.current) {
                planAccessUnsubscribeRef.current();
                planAccessUnsubscribeRef.current = null;
              }
              if (subId) {
                runPlanSettingsEnforcement({
                  companyId: currentUserData?.companyId || currentUserData?.id || null,
                  planId: subId,
                  planAccess,
                });
                planAccessUnsubscribeRef.current = subscribePlanAccessByStripeProductId(
                  subId,
                  (livePlanAccess) => {
                    if (typeof window !== "undefined") {
                      window.__CURRENT_PLAN_ACCESS__ = livePlanAccess || null;
                      window.__PLAN_ACCESS_BY_PRODUCT__ = {
                        ...(window.__PLAN_ACCESS_BY_PRODUCT__ || {}),
                        [subId]: livePlanAccess,
                      };
                    }
                    setUserProfile((prev) =>
                      prev
                        ? { ...prev, planAccess: livePlanAccess, plansAccess: livePlanAccess }
                        : prev
                    );
                    runPlanSettingsEnforcement({
                      companyId: currentUserData?.companyId || currentUserData?.id || null,
                      planId: subId,
                      planAccess: livePlanAccess,
                    });
                    updateCachedPlanAccess(user.uid, livePlanAccess);
                  }
                );
              }
              startCompanyPlanListener({
                isCompanyUser,
                trackedUserId: currentUserData?.companyId || currentUserData?.id || null,
                initialPlanProductId: subId || null,
              });
              setUserProfile(freshProfile);
              setsubstatus(!isValid);
              saveLoginCache({
                userId: user.uid,
                companyId,
                token: currentuser?.token,
                clients: clientsDetails,
                emps: employees,
                appointments,
                allEmps: allEmpRes?.data || [],
                userProfile: freshProfile,
                substatus: !isValid
              });
            } catch (_err) {
              // Background refresh failed; keep showing cached UI
            }
          })();
          return;
        }

        let pendingVerifications = [];
        let cardsData = {
          cards: [],
          defaultPaymentMethodId: null
        };

        if (userRoles.includes("companyUser") && !user.emailVerified) {
          setIsLoading(false);
          navigate("/verify-email-sent");
          return;
        }

        // Phase 1: Fetch subscription first to show dashboard faster
        const subscriptionData = await fetchSubscriptionWithCustomer(currentUserData?.customer);

        if (!subscriptionData?.data?.length) {
          setIsLoading(false);
          return;
        }

        // Phase 2: Fire employees/clients and sidebar badges in parallel (do NOT await)
        const empClientPromise = Promise.all([
          new Promise((resolve, _reject) => {
            getCompanyEmployees(
              companyId,
              (res) => resolve(res),
              (_err) => resolve({ status: false, data: [] })
            );
          }),
          new Promise((resolve, _reject) => {
            getCompanyClients(
              companyId,
              (res) => resolve(res),
              (_err) => resolve({ status: false, data: [] }),
            );
          }),
        ]);

        setCompanyAppointmentsSample([]);
        setClients([]);
        setEmps([]);
        setGuidedTourEligibility({
          isResolved: false,
          hasClients: false,
          hasEmployees: false,
          hasAppointments: false,
        });

        loadStartupSidebarSignals(companyId, currentUserData);
        setTimeout(() => {
          getHighPrioritySupply(companyId, currentUserData?.role, currentUserData?.id);
        }, 100);

        // Optimize: Single pass through subscriptions array
        const subscriptions = subscriptionData?.data || [];
        const blockedPriceIds = new Set([
          "price_1R1Pm6H54HzvHwSdzS4aA0s9",
          "price_1RGH20H54HzvHwSdZTHWjNHO",
        ]);

        let filteredSubs = [];
        let canceledSubs = [];
        let activeSub = null;
        let trialingSub = null;
        let latestCanceled = null;

        // Single pass optimization
        subscriptions.forEach((sub) => {
          const hasBlockedPrice = sub?.items?.data?.some((item) =>
            blockedPriceIds.has(item?.price?.id)
          );

          if (!hasBlockedPrice) {
            filteredSubs.push(sub);

            if (sub?.status === "active" && !activeSub) {
              activeSub = sub;
            } else if (sub?.status === "trialing" && !trialingSub) {
              trialingSub = sub;
            } else if (sub?.status === "canceled") {
              canceledSubs.push(sub);
              if (!latestCanceled || sub?.created > latestCanceled?.created) {
                latestCanceled = sub;
              }
            }
          }
        });

        const fallbackSub = activeSub || trialingSub || latestCanceled;
        let subscriptionSchedule = null;
        if (fallbackSub?.schedule) {
          subscriptionSchedule = await getSubscriptionSchedule(fallbackSub.schedule);
        }

        const userSub = currentUserData?.subscriptions?.data?.[0];
        const additionalSubscriptions = currentUserData?.subscriptions?.additionalData || [];

        // eslint-disable-next-line no-unused-vars
        const subscriptionEndTimestamp =
          fallbackSub?.current_period_end || userSub?.current_period_end;
        const subscriptionStatus = fallbackSub?.status || userSub?.status;
        const subscriptionId = fallbackSub?.plan?.product || userSub?.plan?.product;
        const planAccess = await getPlanAccessByStripeProductId(subscriptionId);

        let quantity = 1;
        if (subscriptionStatus === "trialing") {
          quantity = 5;
        } else {
          const baseQty = userSub?.quantity || fallbackSub?.quantity || 0;
          const seatAddons = getSeatAddonQuantities(additionalSubscriptions, validateSubscription);
          const addQty = seatAddons.fieldUser || 0;
          quantity = baseQty + addQty;
        }
        const seatAddons = getSeatAddonQuantities(additionalSubscriptions, validateSubscription);

        const isValid = isSubscriptionValid(userSub, fallbackSub, currentUserData);

        // Show dashboard immediately with subscription data; employees/clients load in background
        const userProfileData = {
          ...currentUserData,
          emailVerified: userData?.emailVerified,
          subscriptionDetails: fallbackSub,
          subscriptionSchedule,
          companyActiveUsers: 0,
          lastLogin: userData?.metadata?.lastSignInTime,
          prdId: subscriptionId,
          fieldAdditionalQuantity: seatAddons.fieldUser || 0,
          backOfficeAdditionalQuantity: seatAddons.backOffice || 0,
          quantity,
          storage: null,
          clientsLength: 0,
          employeesLength: 0,
          employees: [],
          companyData: null,
          pendingVerifications: pendingVerifications || [],
          cardsData: cardsData,
          cardsDataLoaded: false,
          planAccess : planAccess
        };
        if (typeof window !== "undefined") {
          window.__CURRENT_PLAN_ACCESS__ = planAccess || null;
          if (subscriptionId && planAccess) {
            window.__PLAN_ACCESS_BY_PRODUCT__ = {
              ...(window.__PLAN_ACCESS_BY_PRODUCT__ || {}),
              [subscriptionId]: planAccess,
            };
          }
        }
        if (planAccessUnsubscribeRef.current) {
          planAccessUnsubscribeRef.current();
          planAccessUnsubscribeRef.current = null;
        }
        if (subscriptionId) {
          runPlanSettingsEnforcement({
            companyId: currentUserData?.companyId || currentUserData?.id || null,
            planId: subscriptionId,
            planAccess,
          });
          planAccessUnsubscribeRef.current = subscribePlanAccessByStripeProductId(
            subscriptionId,
            (livePlanAccess) => {
              if (typeof window !== "undefined") {
                window.__CURRENT_PLAN_ACCESS__ = livePlanAccess || null;
                window.__PLAN_ACCESS_BY_PRODUCT__ = {
                  ...(window.__PLAN_ACCESS_BY_PRODUCT__ || {}),
                  [subscriptionId]: livePlanAccess,
                };
              }
              setUserProfile((prev) =>
                prev
                  ? { ...prev, planAccess: livePlanAccess, plansAccess: livePlanAccess }
                  : prev
              );
              runPlanSettingsEnforcement({
                companyId: currentUserData?.companyId || currentUserData?.id || null,
                planId: subscriptionId,
                planAccess: livePlanAccess,
              });
              updateCachedPlanAccess(user.uid, livePlanAccess);
            }
          );
        }
        startCompanyPlanListener({
          isCompanyUser,
          trackedUserId: currentUserData?.companyId || currentUserData?.id || null,
          initialPlanProductId: subscriptionId || null,
        });

        setUserProfile(userProfileData);
        setauthstatus(true);
        startSessionTimers({ resetExisting: freshManualAuthFlow });
        setsubstatus(!isValid);
        setIsLoading(false);

        // Phase 3: Load employees/clients in background and update state when ready
        empClientPromise.then(([allEmpRes, clientRes]) => {
          const clientsDetails = clientRes?.data?.filter((item) => item?.status !== false) || [];
          const employees = allEmpRes?.data?.filter((item) => item?.status !== false) || [];
          const allEmps = allEmpRes?.data || [];
          const companyActiveUsers =
            currentUserData?.role === "companyUser"
              ? allEmps?.reduce((count, e) =>
                (e.companyId === currentUserData?.id &&
                  e.role === "Employee" &&
                  e.status === true) ? count + 1 : count, 0)
              : 0;

          setClients(clientsDetails);
          setEmps(employees);
          setAllEmps(allEmps);
          setUserProfile((prev) => prev ? {
            ...prev,
            companyActiveUsers,
            clientsLength: clientsDetails?.length,
            employeesLength: employees?.length,
            employees: allEmps
          } : prev);
          saveLoginCache({
            userId: user.uid,
            companyId,
            token: currentuser?.token,
            clients: clientsDetails,
            emps: employees,
            appointments: [],
            allEmps,
            userProfile: { ...userProfileData, companyActiveUsers, clientsLength: clientsDetails?.length, employeesLength: employees?.length, employees: allEmps },
            substatus: !isValid
          });
        });

        // Phase 4: Deferred APIs - load in background (appointments, companyData, storage)
        // Payment APIs are loaded on-demand when Upgrade page mounts (see loadPaymentData in context)
        (async () => {
          try {
            const [[allEmpRes, clientRes], [appointmentRes, companyDataRes, storageRes]] = await Promise.all([
              empClientPromise,
              Promise.all([
                getCompanyAppointmentsSample(companyId, 5).catch(() => ({ appointments: [] })),
                new Promise((resolve) => getEmployee(companyId, (r) => resolve(r))).catch(() => null),
                getUsedStorage(companyId).catch(() => null)
              ])
            ]);

            const clientsDetails = clientRes?.data?.filter((item) => item?.status !== false) || [];
            const employees = allEmpRes?.data?.filter((item) => item?.status !== false) || [];
            const allEmps = allEmpRes?.data || [];
            const appointments = appointmentRes?.appointments || [];
            const companyData = companyDataRes?.status && companyDataRes?.data ? companyDataRes.data : null;

            setCompanyAppointmentsSample(appointments);
            setGuidedTourEligibility({
              isResolved: true,
              hasClients: clientsDetails.length > 0,
              hasEmployees: employees.length > 0,
              hasAppointments: appointments.length > 0,
            });

            setUserProfile((prev) => ({
              ...prev,
              storage: storageRes,
              companyData
            }));

            saveLoginCache({
              userId: user.uid,
              companyId,
              token: currentuser?.token,
              clients: clientsDetails,
              emps: employees,
              appointments,
              allEmps,
              userProfile: {
                ...userProfileData,
                storage: storageRes,
                companyData
              },
              substatus: !isValid
            });
          } catch (_err) {
            // Deferred load failed; keep showing UI with partial data
          }
        })();
      } catch (err) {
        console.error("Login error:", err);
        // Keep authenticated Firebase session. If background profile APIs fail,
        // do not bounce the user back to login.
        setsubstatus(false);
        setIsLoading(false);
      }
    });

    return unsubscribe;
  };

  const startAuthListener = (_token, options) => {
    loginPreloadRef.current = options?.preloadedUserSnapshot ?? null;

    if (authUnsubscribeRef.current && typeof authUnsubscribeRef.current === "function") {
      authUnsubscribeRef.current();
      authUnsubscribeRef.current = null;
    }

    authUnsubscribeRef.current = login(_token);
    return authUnsubscribeRef.current;
  };

  const logoutuser = async (isForceLogout = false) => {
    concurrentSessionModalBlockingRef.current = false;
    setConcurrentSessionModalOpen(false);
    setConcurrentSessionContinueLoading(false);
    // Tear down session timers and clear expiry timestamps first so that no
    // further timeout callbacks can fire during the logout sequence.
    sessionManager.end();
    setIsLoading(true);
    const user = getAuth().currentUser;
    if (user && !isForceLogout) {
      try {
        await updateUserSession(user.uid, null);
      } catch (error) {
        console.error("Error clearing session on logout:", error);
      }
    }

    if (sessionUnsubscribeRef.current) {
      sessionUnsubscribeRef.current();
      sessionUnsubscribeRef.current = null;
    }
    if (planAccessUnsubscribeRef.current) {
      planAccessUnsubscribeRef.current();
      planAccessUnsubscribeRef.current = null;
    }
    clearCompanyPlanListener();
    if (concurrentSessionLogoutTimeoutRef.current) {
      clearTimeout(concurrentSessionLogoutTimeoutRef.current);
      concurrentSessionLogoutTimeoutRef.current = null;
    }

    if (channelUnsubscribeRef.current) {
      channelUnsubscribeRef.current();
      channelUnsubscribeRef.current = null;
    }

    clearLoginToken();
    logOut();

    // Reset local states immediately so UI updates
    setauthstatus(false);
    setUserProfile(false);
    setsubstatus(false);
    setLoginBack(true);
    setGuidedTourEligibility({
      isResolved: false,
      hasClients: false,
      hasEmployees: false,
      hasAppointments: false,
    });

    setSessionWarning(false);
    setPlanChangedModalOpen(false);
    setPlanChangedLogoutLoading(false);
    clearAuthStorage();

    navigate('/login')
    setIsLoading(false);
  };
  const loadPaymentData = React.useCallback(async () => {
    const profile = userProfile;
    if (!profile || profile?.role !== "companyUser") return;
    try {
      const [pendingResults, paymentMethods] = await Promise.all([
        getPendingPaymentVerificationByUser(profile?.id, ["during_verification", "pending_verification"]).catch(() => ({ during_verification: [], pending_verification: [] })),
        getCustomerPaymentMethods(profile?.customer).catch(() => null)
      ]);
      let pVerifications = [];
      let pCardsData = { cards: [], defaultPaymentMethodId: null };
      if (pendingResults?.during_verification?.length) pVerifications = pendingResults.during_verification;
      if (pendingResults?.pending_verification?.length) {
        const pACH = pendingResults.pending_verification.map((item) => ({
          id: item.paymentMethod.id,
          setupIntentId: item.setupIntentId,
          type: "us_bank_account",
          bank_name: item.paymentMethod.us_bank_account?.bank_name,
          last4: item.paymentMethod.us_bank_account?.last4,
          account_holder_type: item.paymentMethod.us_bank_account?.account_holder_type,
          account_type: item.paymentMethod.us_bank_account?.account_type,
          status: item.status,
        }));
        pCardsData = {
          cards: [...(paymentMethods?.cards || []), ...pACH],
          defaultPaymentMethodId: paymentMethods?.defaultPaymentMethodId || null
        };
      } else if (paymentMethods) {
        pCardsData = {
          cards: paymentMethods?.cards || [],
          defaultPaymentMethodId: paymentMethods?.defaultPaymentMethodId || null
        };
      }
      setUserProfile((prev) => prev ? {
        ...prev,
        pendingVerifications: pVerifications,
        cardsData: pCardsData,
        cardsDataLoaded: true,
      } : prev);
    } catch (_err) {
      // Silent fail
    }
  }, [userProfile?.id, userProfile?.customer, userProfile?.role]);

  logoutRef.current = logoutuser;

  const closeConcurrentSessionModal = React.useCallback(() => {
    concurrentSessionModalBlockingRef.current = false;
    setConcurrentSessionModalOpen(false);
    setConcurrentSessionModalVariant("competing");
    setConcurrentSessionContinueLoading(false);
  }, []);

  const handleConcurrentLogoutHere = React.useCallback(() => {
    closeConcurrentSessionModal();
    logoutRef.current?.(true);
  }, [closeConcurrentSessionModal]);

  const handleConcurrentContinueHere = React.useCallback(async () => {
    const auth = getAuth();
    const uid = auth.currentUser?.uid;
    if (!uid) {
      handleConcurrentLogoutHere();
      return;
    }
    setConcurrentSessionContinueLoading(true);
    try {
      const deviceInfo = await getDeviceInfo();
      const res = await updateUserSession(uid, deviceInfo, true);
      if (!res?.status) {
        throw new Error("Session update failed");
      }
      const sessionId = resolveServerSessionId(res);
      markFreshAuthFlow(sessionId);
      clearSessionEnteredViaForceLogin();
      closeConcurrentSessionModal();
    } catch (_e) {
      setConcurrentSessionContinueLoading(false);
      window.alert("Could not keep this session on this device. Try again or log out.");
    }
  }, [closeConcurrentSessionModal, handleConcurrentLogoutHere]);

  const handlePlanChangedAcknowledge = React.useCallback(async () => {
    if (planChangedLogoutLoading) return;
    setPlanChangedLogoutLoading(true);
    await logoutRef.current?.();
    setPlanChangedLogoutLoading(false);
  }, [planChangedLogoutLoading]);

  useEffect(() => {
    const stableHandler = (...args) => logoutRef.current?.(...args);
    EventEmitter.subscribe("logoutUser", stableHandler);
    return () => EventEmitter.unsubscribe("logoutUser", stableHandler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        lastFocusRef.current = Date.now();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  useEffect(() => {
    sessionManager.onTimeout((reason) => {
      console.info(`[Session] Timeout triggered (${reason}). Logging out.`);
      logoutRef.current?.();
    });
    sessionManager.onWarning(() => {
      setSessionWarning(true);
    });
    sessionManager.onWarningDismiss(() => {
      setSessionWarning(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const authContextValue = useMemo(
    () => ({
      status: authstatus,
      userProfile: userProfile,
      login: startAuthListener,
      currentChannel: currentChannel,
      setCurrentChannel: setCurrentChannel,
      isReadPrivate: isReadPrivate,
      isReadPublic: isReadPublic,
      setIsReadPrivate: setIsReadPrivate,
      setIsReadPublic: setIsReadPublic,
      logoutuser: logoutuser,
      pendingSupplyStatus: pendingSupplyStatus,
      highPrioritySupply: highPrioritySupply,
      setPendingSupplyStatus: setPendingSupplyStatus,
      issueCount: issueCount,
      setIssueCount: setIssueCount,
      isLoading: isLoading,
      resetPendingSupplyStatus,
      resetHighPrioritySupply,
      resetIssueCount,
      tableState,
      setTableState,
      setEditAppointmentData,
      setUpdateAppointmentData,
      updateAppointmentData,
      editAppointmentData,
      setAppointmentsData,
      appointmentsData,
      setSelectedAppointment,
      selectedAppointment,
      setIsModalOpen,
      isModalOpen,
      setIsExpanded,
      setNewClientId,
      newClientId,
      setNewEmpId,
      newEmpId,
      isExpanded,
      supplieStatusCount,
      setsubstatus,
      substatus,
      loginBack,
      setLoginBack,
      setPendingSupportStatus: setPendingSupportStatus,
      pendingSupportStatus: pendingSupportStatus,
      resetPendingSupportStatus,
      setSupplyId,
      supplyId,
      setReportData,
      reportData,
      clients,
      allEmp,
      loadPaymentData,
      sessionWarning,
    }),
    [
      appointmentsData,
      authstatus,
      clients,
      currentChannel,
      editAppointmentData,
      highPrioritySupply,
      isExpanded,
      isLoading,
      isModalOpen,
      isReadPrivate,
      isReadPublic,
      issueCount,
      loadPaymentData,
      loginBack,
      newClientId,
      newEmpId,
      pendingSupportStatus,
      pendingSupplyStatus,
      reportData,
      resetHighPrioritySupply,
      resetIssueCount,
      resetPendingSupplyStatus,
      resetPendingSupportStatus,
      selectedAppointment,
      sessionWarning,
      substatus,
      supplieStatusCount,
      supplyId,
      tableState,
      updateAppointmentData,
      userProfile,
      allEmp,
    ]
  );

  return (
    <ErrorBoundary>
      <AuthContext.Provider
        value={authContextValue}
      >

        <ThemeProvider theme={theme}>
          <CssBaseline />
          <ConcurrentSessionModal
            open={concurrentSessionModalOpen}
            variant={concurrentSessionModalVariant}
            onContinueHere={handleConcurrentContinueHere}
            onLogoutHere={handleConcurrentLogoutHere}
            continueLoading={concurrentSessionContinueLoading}
          />
          <PlanChangedModal
            open={planChangedModalOpen}
            onAcknowledge={handlePlanChangedAcknowledge}
            loading={planChangedLogoutLoading}
          />
          <AnalyticsTracker />
          {authstatus && (path === "/login" || path === "/" || path === "/register") ? (
            <Navigate
              to={normalizeRoles(userProfile?.role).includes("superUser") ? "/superuserDashboard" : "/dashboard"}
              replace
            />
          ) : authstatus ? (
            <>
              {ENABLE_GUIDED_TOUR && <TourBubble />}
              <OnboardingExperienceProvider>
                <AuthenticatedApp
                  props={props}
                  isLoading={isLoading}
                  path={path}
                  guidedTourEligibility={guidedTourEligibility}
                />
              </OnboardingExperienceProvider>
            </>
          ) : !authstatus && !PUBLIC_AUTH_ROUTES.includes(path) && isLoading ? (
            <Loader />
          ) : (
            <AppRoutes {...props} isLoading={isLoading} />
          )}
        </ThemeProvider>
      </AuthContext.Provider>
    </ErrorBoundary>
  );
}

export default App;
